import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { BaseFormList, MessageService } from '../../../../../core';
import { UsuarioEmailAdministrativo } from '../usuario-email-administrativo';

@Component({
    selector: 'sgt-usuario-email-administrativo-form',
    templateUrl: './usuario-email-administrativo-form.component.html',
    styleUrls: ['./usuario-email-administrativo-form.component.less']
})
export class UsuarioEmailAdministrativoFormComponent implements BaseFormList<UsuarioEmailAdministrativo> {
    @Input() entities: UsuarioEmailAdministrativo[];
    @ViewChild('form') form: NgForm;

    constructor(private messageService: MessageService) { }

    /** Insere um e-mail administrativo */
    insert() {
        const entity = new UsuarioEmailAdministrativo();
        this.entities.push(entity);
    }

    /** Exclui um e-mail administrativo */
    delete(index: number) {
        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente excluir o e-mail ${entity.email}?`).then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se os e-mails administrativos estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];

            // Duplicação
            const count = this.entities.filter(entityFilter => entityFilter.email && entityFilter.email === entity.email).length;
            if (count > 1) {
                this.messageService.info(`O e-mail ${entity.email} já está adicionado. Remova ou altere o e-mail duplicado`, 'Não é possível adicionar dois e-mails iguais');
                return false;
            }
        }

        if (this.form.invalid) {
            this.messageService.info('Preencha corretamente todas as informações dos e-mails administrativos', 'E-mails administrativos inválidos');
            return false;
        }

        return true;
    }

    /** Resolve os e-mails administrativos */
    resolve() {
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.email) {
                this.entities.splice(i, 1);
            }
        }
    }
}
